import { render, staticRenderFns } from "./WorkerContractInfo.vue?vue&type=template&id=28e404d9&"
import script from "./WorkerContractInfo.vue?vue&type=script&lang=js&"
export * from "./WorkerContractInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports